import React, { FC, useState, useEffect } from 'react';
import { Box, Chip, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OmnichannelQuery } from '../../../../services/query';
import { OmnichannelCommand } from '../../../../services/command';
import Swal from 'sweetalert2';
import { SM_OFS } from './operationFlagService.classes';

const BadgeChip: FC<{ label: string }> = ({ label }) => (
    <Chip
        label={label}
        size="small"
        sx={{
            bgcolor: '#0039a6',
            color: 'white',
            fontWeight: 700,
            fontSize: 11,
            borderRadius: 1,
            width: 48,
            mr: 2,
            '& .MuiChip-label': { px: 0.5 },
        }}
        className={SM_OFS.badge}
    />
);

export const OperationFlagService: FC = () => {
    const { t } = useTranslation();
    const [operationFlagValue, setOperationFlagValue] = useState(false);

    const getOperationFlagValue = () => {
        OmnichannelQuery.GetOperationFlagValue().then((res: any) => {
            if (res.data.data) {
                setOperationFlagValue(res.data.data.flagValue ? res.data.data.flagValue : false);
            }
        });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        Swal.fire({
            text: t('authorizationManagement.listUser.surePassiveText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.OperationFlagValue = !event.target.checked === true ? true : false;
                OmnichannelCommand.SaveOperationFlagValue(params)
                    .then(() => {
                        setOperationFlagValue(params.OperationFlagValue);
                        Swal.fire(t('general.updated'), ' ', 'success');
                    })
                    .catch((error: any) => {
                        console.log('Hata :>> ', error);
                    });
            }
        });
    };

    useEffect(() => {
        getOperationFlagValue();
    }, []);

    return (
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
                px: 3,
                py: 1,
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                maxWidth: 560,
                width: '100%',
            }}
            className={SM_OFS.card}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 52 }} className={SM_OFS.row}>
                <Typography variant="body2" fontWeight={600} sx={{ flex: 1 }} className={SM_OFS.title}>
                    {t('serviceManagement.expectedDeliveryDate')}
                </Typography>
                <BadgeChip label="LCW" />
                <Switch checked={operationFlagValue} onChange={handleChange} className={SM_OFS.toggle} />
            </Box>
        </Box>
    );
};
